import appConfig from "@src/app.config";

export const configClientes = {
  telaLogin,
  logo
};

function telaLogin() {
  switch (appConfig.empresa) {
    case "fps":
      return import("@views/LoginFPS");
    case "sisloc":
      return import("@views/LoginApi");
    default:
      return import("@views/Login");
  }
}

function logo() {
  switch (appConfig.empresa) {
    case "sisloc":
      return "@assets/images/Sisloc/LogoSisloc.png";
    default:
      return "@assets/images/logo-dark.png";
  }
}

export default configClientes;
